import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaceToUnderscore',
})

export class SpaceToUnderscorePipe implements PipeTransform {
  previousValue!: string;
  resultCached!: string;

  transform(value: string) {
    // Skip calculation if value hasn't changed
    if ((value === this.previousValue) && this.resultCached) {
      return this.resultCached;
    }
    this.previousValue = value;

    if (value) {
      value = value.toString().replace(/ /g, '_');
    } else {
      value = '';
    }

    this.resultCached = value;
    return value;
  }
}
